module.exports = __webpack_public_path__ + "static/media/google-play.7314fb98.png";